export default (theme) => ({
  h1: {
    fontSize: 48,
    fontWeight: 400,
    marginBottom: 25,
    marginTop: 25,
    opacity: 0.7,
  },
  h2: {
    fontSize: 28,
    fontWeight: 500,
    paddingBottom: 4,
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.4)"
        : "rgba(0,0,0,0.4)"
    }`,
    width: "100%",
    display: "block",
    marginBottom: 25,
    marginTop: 25,
  },
  h3: {
    fontSize: 26,
    marginBottom: 25,
    marginTop: 25,
  },
  h4: {
    fontSize: 22,
    marginBottom: 25,
    marginTop: 25,
  },
  h5: {
    fontSize: 18,
    marginBottom: 25,
    marginTop: 25,
  },
  h6: {
    fontSize: 16,
    color: theme.palette.text,
    marginBottom: 25,
    marginTop: 25,
    opacity: 0.5,
  },
});
